export const products = {
  heaters: [
    {
      id: 'G50B',
      model: 'G50B',
      name: {
        it: 'Riscaldatore a infrarossi 500W (Nero)',
        ru: 'Инфракрасный обогреватель 500Вт (Черный)'
      },
      type: 'heater',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '61mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '9 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m²',
      color: 'black',
      gtin: '4745010656088',
      url: 'https://gpo-store.com/products/compact-infrared-glass-heater-500w',
      price: '€299',
      images: [
        '/images/products/G50B/G50B-first.jpg',
        '/images/products/G50B/G50B_1.jpg',
        '/images/products/G50B/G50B_2.jpg',
        '/images/products/G50B/G50B_3.jpg',
        '/images/products/G50B/G50B_4.jpg',
        '/images/products/G50B/G50B_5.jpg'
      ],
      description: {
        it: 'Riscaldatore a infrarossi compatto in vetro. Ideale per piccoli ambienti. Funzionamento silenzioso, sicuro per bambini e animali domestici.',
        ru: 'Компактный инфракрасный стеклянный обогреватель. Идеален для небольших помещений (до 25 кв м). Бесшумная работа, безопасен для детей и питомцев.'
      }
    },
    {
      id: 'G50W',
      model: 'G50W',
      name: {
        it: 'Riscaldatore a infrarossi compatto 500W (Bianco)',
        ru: 'Инфракрасный обогреватель 500Вт (Белый)'
      },
      type: 'heater',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '61mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '9 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m²',
      color: 'white',
      gtin: '4745010656095',
      url: 'https://gpo-store.com/products/compact-infrared-glass-heater-500w',
      price: '€299',
      images: [
        '/images/products/G50W/G50W-first.jpg',
        '/images/products/G50W/G50W_1.jpg',
        '/images/products/G50W/G50W_2.jpg',
        '/images/products/G50W/G50W_3.jpg',
        '/images/products/G50W/G50W_4.jpg',
        '/images/products/G50W/G50W_5.jpg'
      ],
      description: {
        it: 'Riscaldatore a infrarossi compatto in vetro bianco. Il design premium si adatta perfettamente a qualsiasi ambiente interno. Funzionamento silenzioso, sicuro per bambini e animali domestici.',
        ru: 'Компактный инфракрасный стеклянный обогреватель белого цвета. Премиальный дизайн идеально вписывается в любой интерьер. Бесшумная работа, безопасен для детей и питомцев.'
      }
    },
    {
      id: 'G67B-V',
      model: 'G67B-V',
      name: {
        it: 'Riscaldatore a infrarossi premium 670W (Nero, verticale)',
        ru: 'Премиум инфракрасный обогреватель 670Вт (Черный, вертикальный)'
      },
      type: 'heater',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '61mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m²',
      color: 'black',
      gtin: '4745010656217',
      url: 'https://gpo-store.com/products/premium-infrared-silent-glass-heater-in-black-670w?variant=51179846107465',
      price: '€349',
      images: [
        '/images/products/G67B-V/G67B-first.jpg',
        '/images/products/G67B-V/G67B-V_1.jpg',
        '/images/products/G67B-V/G67B-V_2.jpg',
        '/images/products/G67B-V/G67B-V_3.jpg',
        '/images/products/G67B-V/G67B-V_4.jpg',
        '/images/products/G67B-V/G67B-V_5.jpg'
      ],
      description: {
        it: 'Riscaldatore a infrarossi silenzioso premium con installazione verticale. Design nero elegante, controllo intelligente tramite app. Sicuro per bambini e animali domestici.',
        ru: 'Премиальный тихий обогреватель вертикальной установки. Элегантный черный дизайн, умное управление через приложение. Бесшумная работа, безопасен для детей и питомцев.'
      }
    },
    {
      id: 'G67W-V',
      model: 'G67W-V',
      name: {
        it: 'Riscaldatore a infrarossi premium 670W (Bianco, verticale)',
        ru: 'Премиум инфракрасный обогреватель 670Вт (Белый, вертикальный)'
      },
      type: 'heater',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '61mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m²',
      color: 'white',
      gtin: '4745010656200',
      url: 'https://gpo-store.com/products/premium-infrared-silent-glass-heater-670w?variant=51179828379977',
      price: '€349',
      images: [
        '/images/products/G67W-V/G67W-first.jpg',
        '/images/products/G67W-V/G67W-V_1.jpg',
        '/images/products/G67W-V/G67W-V_2.jpg',
        '/images/products/G67W-V/G67W-V_3.jpg',
        '/images/products/G67W-V/G67W-V_4.jpg',
        '/images/products/G67W-V/G67W-V_5.jpg'
      ],
      description: {
        it: 'Elegante riscaldatore a infrarossi bianco di classe premium. Design ultra-sottile di soli 11mm. Funzionamento silenzioso, sicuro per bambini e animali domestici.',
        ru: 'Элегантный белый обогреватель премиум класса. Ультратонкий дизайн всего 11мм. Бесшумная работа. Бесшумная работа, безопасен для детей и питомцев.'
      }
    }
  ],
  towelDryers: [
    {
      id: 'T50B-F1',
      model: 'T50B-F1',
      name: {
        it: 'Scaldasalviette a infrarossi 500W (Nero, 1 barra)',
        ru: 'Полотенцесушитель-обогреватель 500Вт (Черный, 1 перекладина)'
      },
      type: 'towel-dryer',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '9.5 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m²',
      color: 'black',
      racks: 1,
      gtin: '4745010656170',
      url: 'https://gpo-store.com/products/500w-towel-dryer-heater',
      price: '€329',
      images: [
        '/images/products/T50B-F1/T50B-F1_1.jpg',
        '/images/products/T50B-F1/T50B-F1_2.jpg',
        '/images/products/T50B-F1/T50B-F1_3.jpg',
        '/images/products/T50B-F1/T50B-F1_4.jpg',
        '/images/products/T50B-F1/T50B-F1_5.jpg'
      ],
      description: {
        it: 'Elegante scaldasalviette con riscaldamento di tutta la piastra. Barre in acciaio inossidabile, asciugatura salviette e riscaldamento bagno.',
        ru: 'Стильный полотенцесушитель с нагревом всей пластины. Нержавеющие перекладины, сушка полотенец и обогрев ванной.'
      }
    },
    {
      id: 'T50B-F2',
      model: 'T50B-F2',
      name: {
        it: 'Scaldasalviette a infrarossi 500W (Nero, 2 barre)',
        ru: 'Полотенцесушитель-обогреватель 500Вт (Черный, 2 перекладины)'
      },
      type: 'towel-dryer',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m²',
      color: 'black',
      racks: 2,
      gtin: '4745010656163',
      url: 'https://gpo-store.com/products/500w-towel-dryer-heater?variant=51179804098889',
      price: '€349',
      images: [
        '/images/products/T50B-F2/T50B-F2_1.jpg',
        '/images/products/T50B-F2/T50B-F2_2.jpg',
        '/images/products/T50B-F2/T50B-F2_3.jpg',
        '/images/products/T50B-F2/T50B-F2_4.jpg',
        '/images/products/T50B-F2/T50B-F2_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette con due barre per maggiori salviette. Riscaldamento efficace del bagno.',
        ru: 'Полотенцесушитель с двумя перекладинами для большего количества полотенец. Эффективный обогрев ванной комнаты.'
      }
    },
    {
      id: 'T50W-F1',
      model: 'T50W-F1',
      name: {
        it: 'Scaldasalviette a infrarossi 500W (Bianco, 1 barra)',
        ru: 'Полотенцесушитель-обогреватель 500Вт (Белый, 1 перекладина)'
      },
      type: 'towel-dryer',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '9.5 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m²',
      color: 'white',
      racks: 1,
      gtin: '4745010656187',
      url: 'https://gpo-store.com/products/500w-towel-dryer-heater?variant=51179804131657',
      price: '€329',
      images: [
        '/images/products/T50W-F1/T50W-F1_1.jpg',
        '/images/products/T50W-F1/T50W-F1_2.jpg',
        '/images/products/T50W-F1/T50W-F1_3.jpg',
        '/images/products/T50W-F1/T50W-F1_4.jpg',
        '/images/products/T50W-F1/T50W-F1_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette bianco dal design premium. Il riscaldamento di tutta la piastra in vetro garantisce un\'asciugatura uniforme.',
        ru: 'Белый полотенцесушитель премиум дизайна. Нагрев всей стеклянной пластины обеспечивает равномерную сушку.'
      }
    },
    {
      id: 'T50W-F2',
      model: 'T50W-F2',
      name: {
        it: 'Scaldasalviette a infrarossi 500W (Bianco, 2 barre)',
        ru: 'Полотенцесушитель-обогреватель 500Вт (Белый, 2 перекладины)'
      },
      type: 'towel-dryer',
      power: '500W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-10 m²',
      color: 'white',
      racks: 2,
      gtin: '4745010656194',
      url: 'https://gpo-store.com/products/500w-towel-dryer-heater?variant=51179804164425',
      price: '€349',
      images: [
        '/images/products/T50W-F2/T50W-F2_1.jpg',
        '/images/products/T50W-F2/T50W-F2_2.jpg',
        '/images/products/T50W-F2/T50W-F2_3.jpg',
        '/images/products/T50W-F2/T50W-F2_4.jpg',
        '/images/products/T50W-F2/T50W-F2_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette bianco con due barre. Design moderno per bagni luminosi.',
        ru: 'Белый полотенцесушитель с двумя перекладинами. Современный дизайн для светлых интерьеров ванных комнат.'
      }
    },
    {
      id: 'T67B-F2',
      model: 'T67B-F2',
      name: {
        it: 'Scaldasalviette a infrarossi 670W (Nero, 2 barre)',
        ru: 'Полотенцесушитель-обогреватель 670Вт (Черный, 2 перекладины)'
      },
      type: 'towel-dryer',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '11 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m²',
      color: 'black',
      racks: 2,
      gtin: '4745010656156',
      url: 'https://gpo-store.com/products/glass-heater-dryer-for-bathroom?variant=51179475796297',
      price: '€399',
      images: [
        '/images/products/T67B-F2/T67B-F2_1.jpg',
        '/images/products/T67B-F2/T67B-F2_2.jpg',
        '/images/products/T67B-F2/T67B-F2_3.jpg',
        '/images/products/T67B-F2/T67B-F2_4.jpg',
        '/images/products/T67B-F2/T67B-F2_5.jpg'
      ],
      description: {
        it: 'Potente scaldasalviette per bagni grandi. Il design verticale risparmia spazio.',
        ru: 'Мощный полотенцесушитель для больших ванных комнат. Вертикальный дизайн экономит пространство.'
      }
    },
    {
      id: 'T67B-F3',
      model: 'T67B-F3',
      name: {
        it: 'Scaldasalviette a infrarossi 670W (Nero, 3 barre)',
        ru: 'Полотенцесушитель-обогреватель 670Вт (Черный, 3 перекладины)'
      },
      type: 'towel-dryer',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '11.5 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m²',
      color: 'black',
      racks: 3,
      gtin: '4745010656149',
      url: 'https://gpo-store.com/products/glass-heater-dryer-for-bathroom?variant=51179475829065',
      price: '€419',
      images: [
        '/images/products/T67B-F3/T67B-F3-first.jpg',
        '/images/products/T67B-F3/T67B-F3_1.jpg',
        '/images/products/T67B-F3/T67B-F3_2.jpg',
        '/images/products/T67B-F3/T67B-F3_3.jpg',
        '/images/products/T67B-F3/T67B-F3_4.jpg',
        '/images/products/T67B-F3/T67B-F3_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette con tre barre per bagni familiari. Massima capacità per salviette.',
        ru: 'Полотенцесушитель с тремя перекладинами для семейных ванных комнат. Максимальная вместимость полотенец.'
      }
    },
    {
      id: 'T67W-F2',
      model: 'T67W-F2',
      name: {
        it: 'Scaldasalviette a infrarossi 670W (Bianco, 2 barre)',
        ru: 'Полотенцесушитель-обогреватель 670Вт (Белый, 2 перекладины)'
      },
      type: 'towel-dryer',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '11 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m²',
      color: 'white',
      racks: 2,
      gtin: '4745010656125',
      url: 'https://gpo-store.com/products/glass-heater-dryer-for-bathroom?variant=51179475730761',
      price: '€399',
      images: [
        '/images/products/T67W-F2/T67W-F2_1.jpg',
        '/images/products/T67W-F2/T67W-F2_2.jpg',
        '/images/products/T67W-F2/T67W-F2_3.jpg',
        '/images/products/T67W-F2/T67W-F2_4.jpg',
        '/images/products/T67W-F2/T67W-F2_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette bianco di classe premium. Si adatta perfettamente agli interni moderni minimalisti.',
        ru: 'Белый полотенцесушитель премиум класса. Идеально вписывается в современные минималистичные интерьеры.'
      }
    },
    {
      id: 'T67W-F3',
      model: 'T67W-F3',
      name: {
        it: 'Scaldasalviette a infrarossi 670W (Bianco, 3 barre)',
        ru: 'Полотенцесушитель-обогреватель 670Вт (Белый, 3 перекладины)'
      },
      type: 'towel-dryer',
      power: '670W',
      wireless: 'WiFi, Bluetooth',
      size: '1000x365x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '11.5 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      area: '7-12 m²',
      color: 'white',
      racks: 3,
      gtin: '4745010656132',
      url: 'https://gpo-store.com/products/glass-heater-dryer-for-bathroom?variant=51179475763529',
      price: '€419',
      images: [
        '/images/products/T67W-F3/T67W-F3-first.jpg',
        '/images/products/T67W-F3/T67W-F3_1.jpg',
        '/images/products/T67W-F3/T67W-F3_2.jpg',
        '/images/products/T67W-F3/T67W-F3_3.jpg',
        '/images/products/T67W-F3/T67W-F3_4.jpg',
        '/images/products/T67W-F3/T67W-F3_5.jpg'
      ],
      description: {
        it: 'Scaldasalviette bianco premium con tre barre. Trasforma il tuo bagno in una spa. Funzionamento silenzioso, sicuro per bambini e animali domestici.',
        ru: 'Премиальный белый полотенцесушитель с тремя перекладинами. Бесшумная работа, безопасен для детей и питомцев.'
      }
    }
  ],
  shoeDryers: [
    {
      id: 'S10B-F2',
      model: 'S10B-F2',
      name: {
        it: 'Asciuga scarpe a infrarossi 100W (Nero)',
        ru: 'Инфракрасная сушилка для обуви 100Вт (Черная)'
      },
      type: 'shoe-dryer',
      power: '100W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      color: 'black',
      gtin: '474501065610',
      url: 'https://gpo-store.com/products/infrared-shoe-dryer',
      price: '€249',
      images: [
        '/images/products/S10B-F2/S10B-F2_1.jpg',
        '/images/products/S10B-F2/S10B-F2_2.jpg',
        '/images/products/S10B-F2/S10B-F2_3.jpg',
        '/images/products/S10B-F2/S10B-F2_4.jpg',
        '/images/products/S10B-F2/S10B-F2_5.jpg'
      ],
      description: {
        it: 'Asciuga scarpe intelligente con riscaldamento a infrarossi. Asciuga rapidamente e delicatamente le scarpe senza danneggiare i materiali.',
        ru: 'Умная сушилка для обуви с инфракрасным нагревом. Быстро и бережно сушит обувь, не повреждая материалы.'
      }
    },
    {
      id: 'S10W-F2',
      model: 'S10W-F2',
      name: {
        it: 'Asciuga scarpe a infrarossi 100W (Bianco)',
        ru: 'Инфракрасная сушилка для обуви 100Вт (Белая)'
      },
      type: 'shoe-dryer',
      power: '100W',
      wireless: 'WiFi, Bluetooth',
      size: '550x550x11mm',
      fullDeep: '150mm',
      materials: {
        it: 'Vetro temperato, acciaio inossidabile',
        ru: 'Закаленное стекло, нержавеющая сталь'
      },
      weight: '10 kg',
      installation: {
        it: 'A muro (50mm dalla parete)',
        ru: 'Настенный (50мм от стены)'
      },
      color: 'white',
      gtin: '4745010656118',
      url: 'https://gpo-store.com/products/infrared-shoe-dryer?variant=51179383062857',
      price: '€249',
      images: [
        '/images/products/S10W-F2/S10W-F2_1.jpg',
        '/images/products/S10W-F2/S10W-F2_2.jpg',
        '/images/products/S10W-F2/S10W-F2_3.jpg',
        '/images/products/S10W-F2/S10W-F2_4.jpg',
        '/images/products/S10W-F2/S10W-F2_5.jpg'
      ],
      description: {
        it: 'Asciuga scarpe bianco con controllo WiFi. Soluzione moderna per ingresso o guardaroba.',
        ru: 'Белая сушилка для обуви с WiFi управлением. Современное решение для прихожей или гардеробной.'
      }
    }
  ]
};

export const features = {
  it: [
    {
      icon: '🇮🇹',
      title: 'Vendita in Italia',
      description: 'Vendite ufficiali. Consegna rapida, garanzia 5 anni.'
    },
    {
      icon: '🔥',
      title: 'Riscaldamento a infrarossi e convezione',
      description: 'La tecnologia combinata garantisce un riscaldamento rapido e uniforme dell\'ambiente.'
    },
    {
      icon: '💎',
      title: 'Vetro temperato',
      description: 'Materiali robusti e durevoli. Spessore del vetro 11mm con elemento riscaldante interno.'
    },
    {
      icon: '🇪🇪',
      title: 'Produzione Estonia',
      description: 'Alta qualità europea. Made in Estonia con controllo di ogni fase di produzione.'
    },
    {
      icon: '⚡',
      title: 'Risparmio energetico',
      description: 'Riscaldamento efficiente senza costi inutili. Consumo 250-300W/h, risparmio fino al 40%.'
    },
    {
      icon: '✨',
      title: 'Design premium',
      description: 'Corpo ultra-sottile di soli 11mm. Elegante vetro nero o bianco.'
    },
    {
      icon: '👶',
      title: 'Sicurezza',
      description: 'Sicuro per bambini, anziani e animali domestici. Controllo della temperatura superficiale.'
    },
    {
      icon: '🔇',
      title: 'Funzionamento silenzioso',
      description: 'Funzionamento assolutamente silenzioso. Non disturba sonno, lavoro e riposo.'
    },
    {
      icon: '💨',
      title: 'Aria pulita',
      description: 'Non brucia la polvere nell\'aria. Microclima sano nell\'ambiente.'
    },
    {
      icon: '📱',
      title: 'Controllo intelligente',
      description: 'Controllo WiFi e Bluetooth. Funziona anche senza WiFi tramite connessione locale.'
    }
  ],
  ru: [
    {
      icon: '🇮🇹',
      title: 'Продажа в Италии',
      description: 'Официальные продажи. Быстрая доставка, гарантия 5 лет.'
    },
    {
      icon: '🔥',
      title: 'Инфракрасный и конвекционный нагрев',
      description: 'Комбинированная технология обеспечивает быстрый и равномерный обогрев помещения.'
    },
    {
      icon: '💎',
      title: 'Закаленное стекло',
      description: 'Прочные долговечные материалы. Толщина стекла 11мм с внутренним нагревательным элементом.'
    },
    {
      icon: '🇪🇪',
      title: 'Производство Эстония',
      description: 'Высокое европейское качество. Сделано в Эстонии с контролем каждого этапа производства.'
    },
    {
      icon: '⚡',
      title: 'Экономия электроэнергии',
      description: 'Эффективный обогрев без лишних расходов. Потребление 250-300Вт/ч, экономия до 40%.'
    },
    {
      icon: '✨',
      title: 'Премиум дизайн',
      description: 'Ультратонкий корпус всего 11мм. Элегантное черное или белое стекло.'
    },
    {
      icon: '👶',
      title: 'Безопасность',
      description: 'Безопасно для детей, пожилых людей и домашних животных. Контроль температуры поверхности.'
    },
    {
      icon: '🔇',
      title: 'Бесшумная работа',
      description: 'Абсолютно тихая работа. Не мешает сну, работе и отдыху.'
    },
    {
      icon: '💨',
      title: 'Чистый воздух',
      description: 'Не сжигает пыль в воздухе. Здоровый микроклимат в помещении.'
    },
    {
      icon: '📱',
      title: 'Умное управление',
      description: 'WiFi и Bluetooth управление. Работает даже без WiFi через локальное подключение.'
    }
  ]
};

export const contact = {
  address: {
    it: 'Piazza Giuseppe Garibaldi, 10, 87029 Scalea CS',
    ru: 'Piazza Giuseppe Garibaldi, 10, 87029 Scalea CS'
  },
  phone: '+39 379 227 5566',
  email: 'marketing@gpo-home.com',
  company: {
    name: 'GPO OÜ',
    fullAddress: 'Peterburi tee 38/9, Tallinn, Estonia, 11415',
    reg: '14897399',
    vat: 'EE102227529'
  }
};

export const contactInfo = {
  scalea: {
    phone: '+393792275566',
    phoneDisplay: '+39 379 227 5566',
    address: 'Piazza Giuseppe Garibaldi, 10',
    city: '87029 Scalea CS',
    country: 'Italia'
  },
  rimini: {
    phone: '+393887352868',
    phoneDisplay: '+39 388 735 2868',
    address: 'via Coriano 58',
    city: 'Rimini',
    postalCode: 'CAP W78',
    country: 'Italia'
  }
};
